import { render, staticRenderFns } from "./highlight-carousel.vue?vue&type=template&id=6b99eeba&lang=pug"
import script from "./highlight-carousel.vue?vue&type=script&lang=ts"
export * from "./highlight-carousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports